import unpolyLinkHelper from '../modules/unpoly_link_helper'

const DEFAULT_TARGET = ':main'

up.$macro('[modal-link]', function($link) {
  let target = $link.attr('modal-link') || DEFAULT_TARGET
  const layer = $link[0].getAttribute('up-layer') || 'new'
  const size = $link[0].getAttribute('up-size') || 'large'

  let attrs = {
    'up-layer': layer,
    'up-target': target,
    'up-size': size,
  }

  unpolyLinkHelper.setAttributes($link, attrs)
})
